import { getItem, setItem } from '../../util/localStorage';
import { filterObjectByKey } from '../../util/object';
import defaultCompanyValuesSettings from './objects/companyValuesSettings';
import fieldsVisibilitySettings from './objects/fieldsVisibilitySettings';
import defaultValuesSettings from './objects/valuesSettings';

// @TODO: Já daria pra tornar funções async pra simular uma chamada na api,
// deixando semi-pronto para quando for implementado a persistência no backend
export const updateSettings = (settings) => {
  setItem('simulador.re.settings', settings);
};

/**
 * Tratamento feito para aplicar o valor default nas configurações que foram criadas
 * ou renomeadas depois de persistir no local storage.
 *
 * Isso evita erros undefined ao acessar as novas propriedades que não foram
 * persistidas no local storage. Também evita o mesmo erro ao criar novas configurações.
 *
 * @param {Object} settings
 * @returns {Object}
 */
const fallbackToDefaultSettings = (settings) => ({
  defaultValues: {
    ...defaultValuesSettings,
    ...filterObjectByKey(
      settings.defaultValues,
      Object.keys(defaultValuesSettings)
    ),
  },
  defaultCompanyValues: {
    ...defaultCompanyValuesSettings,
    ...filterObjectByKey(
      settings.defaultCompanyValues,
      Object.keys(defaultCompanyValuesSettings)
    ),
  },
  fieldsVisibility: {
    ...fieldsVisibilitySettings,
    ...filterObjectByKey(
      settings.fieldsVisibility,
      Object.keys(fieldsVisibilitySettings)
    ),
  },
});

export const findSettings = () => {
  const settings = getItem('simulador.re.settings');
  if (settings) {
    return fallbackToDefaultSettings(settings);
  }

  return {
    defaultValues: defaultValuesSettings,
    defaultCompanyValues: defaultCompanyValuesSettings,
    fieldsVisibility: fieldsVisibilitySettings,
  };
};
